import { render, staticRenderFns } from "./AgcoHealthCard.vue?vue&type=template&id=edde16f4&scoped=true"
import script from "./AgcoHealthCard.vue?vue&type=script&lang=js"
export * from "./AgcoHealthCard.vue?vue&type=script&lang=js"
import style0 from "./AgcoHealthCard.vue?vue&type=style&index=0&id=edde16f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edde16f4",
  null
  
)

export default component.exports